import React from 'react';
import {ExtendedGridGalleryBase, IGalleryAppProps} from '../../../common/ExtendedGridGallery/ExtendedGridGallery';
import {FooterDescription} from '../FooterDescription/FooterDescription';
import {ConditionalRender} from '../../../common/components/ConditionalRender/ConditionalRender';
import {Experiments} from '../../../constants';
import {withGlobals} from '../../../globalPropsContext';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {withTranslations} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {withRepeatedSlotsPlaceholders} from '@wix/widget-plugins-ooi';

const CategoryPageAppComp: React.FC<IGalleryAppProps> = (props) => {
  const {experiments} = useExperiments();
  const shouldShowFooterDescription = experiments.enabled(Experiments.CategoryPageFooterDescriptionSF);

  const footerContent = (
    <ConditionalRender by={'gallery_showCategoryFooterDescription'}>
      {shouldShowFooterDescription && <FooterDescription />}
    </ConditionalRender>
  );

  return <ExtendedGridGalleryBase {...props} footerContent={footerContent} />;
};

export const CategoryPageApp = withRepeatedSlotsPlaceholders(withGlobals(withTranslations()(CategoryPageAppComp)));
